var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldTipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.008 6.99994H12M12.008 14.9999V9.99994M4 11.2519C4 18.9389 10.918 21.6389 11.887 21.9799C11.9623 22.0066 12.0377 22.0066 12.113 21.9799C13.084 21.6499 20 19.0179 20 11.2529V4.30394C20.0002 4.21457 19.9705 4.1277 19.9156 4.0572C19.8607 3.98669 19.7837 3.93661 19.697 3.91494L12.097 2.01194C12.0333 1.99602 11.9667 1.99602 11.903 2.01194L4.303 3.91494C4.2163 3.93661 4.13935 3.98669 4.08443 4.0572C4.02952 4.1277 3.99979 4.21457 4 4.30394V11.2519Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTipIcon);
export default __webpack_public_path__ + "static/media/shield-tip-icon.4a08d3cd732818174d5905f8e981a2d5.svg";
export { ForwardRef as ReactComponent };